import React from "react";
import PlanCard from "./PlanCard";
import PlanCardSkeleton from "./PlanCardSkeleton";

const PlansGrid = ({
  plans,
  selectedId,
  activeIndex,
  onSelect,
  onCardClick,
  loading = false,
  skeletonCount = 6,
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-3.5">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <PlanCardSkeleton key={`skeleton-${i}`} />
        ))}
      </div>
    );
  }

  const safePlans = Array.isArray(plans) ? plans.filter(Boolean) : [];

  if (safePlans.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center gap-1">
        <p className="text-sm font-semibold text-slate-400">No plans to show</p>
      </div>
    );
  }

  const isSingle = safePlans.length === 1;

  return (
    <div
      className={
        isSingle
          ? "flex justify-center"
          : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-3.5"
      }
    >
      {safePlans.map((plan, i) => {
        const key = plan?.planId ?? plan?.planName ?? plan?.name ?? `plan-${i}`;
        const idForSelection = plan?.planId ?? plan?.planName ?? plan?.name ?? null;
        return (
          <div key={key} className={isSingle ? "w-full max-w-sm" : ""}>
            <PlanCard
              plan={plan}
              selected={idForSelection !== null && selectedId === idForSelection}
              active={activeIndex === i}
              onSelect={onSelect}
              onCardClick={() => onCardClick?.(plan, i)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PlansGrid;